import { Pipe, PipeTransform } from "@angular/core";
import { TrackDataModel } from "../../model";

@Pipe({
    name: 'statusCountFilter',
    standalone: false
})
export class StatusCountFilterPipe implements PipeTransform {

    transform(tracksDataList: TrackDataModel[], statusId: number): number {
        if (tracksDataList) {
            const filteredData = tracksDataList.filter((track: TrackDataModel, idx: number, obj: TrackDataModel[]) => {
                return statusId === 0 || track?.status_id === statusId;
            });

            return filteredData.length
        }

        return 0;
    }

}